import React from 'react';
import { useNavigate } from 'react-router-dom';
import './steps/Steps.css';

const PaymentCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="payment-result-container">
      <div className="payment-result-card cancel">
        <div className="result-icon">🚫</div>
        <h2>Payment Cancelled</h2>
        <p>Your payment was cancelled. No charges were made to your account.</p>

        <div className="cancel-actions">
          <button
            className="btn-primary"
            onClick={() => navigate('/wizard')}
          >
            Try Again
          </button>
          <button
            className="btn-secondary"
            onClick={() => navigate('/')}
          >
            Return Home
          </button>
        </div>

        <div className="help-text">
          <p>
            <strong>Need help?</strong> If you encountered an issue during payment,
            please try again or contact support.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;
